export const alphabeticalSort = (arr: any[], propertyName: string) =>
  arr.sort((a, b) => {
    if (a[propertyName] < b[propertyName]) return -1;
    else if (a[propertyName] > b[propertyName]) return 1;
    return 0;
  });
